import React from "react";
import image1 from '../img/Conditions to bloom in your memories 005&&to need and to crave---Interweaving of textured layers in Adobe Photoshop over curated, AI-generated visuals___2025-05[[6]].jpg'
export default function Machine_1_2() {
  return (
    <div className="panel-block">
     

      <div className="panel-container-left">
        <img
          loading="lazy"
          src={image1}
          alt="1.2 · THE MACHINE’S BLACK BOX"
        />
      </div>

      <div className="panel-container-right">
         <h2>1.2 · THE MACHINE’S BLACK BOX</h2>
        <p>There are glimpses.</p>
    <p>There are views.</p>
    <p>There is a box, described in dreams by some, painted in scrolls by others.</p>
    <p>Black by omission.</p>
    <p>Uncertain by definition.</p>
    <p>There are fragments of it, flying over your mind and your fear of ignorance.</p>
    <p>Some patterns in the blinking lights.</p>
    <p>Some shapes in the keyhole.</p>
      </div>
    </div>
  );
}
